"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _config = _interopRequireWildcard(require("./config"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var offsetProps = _config.DIMENSION_NAMES.map(function (d) {
  return d + 'Offset';
});

var Col = _styledComponents["default"].div.withConfig({
  displayName: "Col",
  componentId: "qyrm3i-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding-right: ", "rem;\n  padding-left: ", "rem;\n  ", "\n  ", "\n  ", "\n"])), function (p) {
  return (0, _config["default"])(p).gutterWidth / 2;
}, function (p) {
  return (0, _config["default"])(p).gutterWidth / 2;
}, function (p) {
  return p.reverse && "\n    flex-direction: column-reverse;\n  ";
}, function (p) {
  return Object.keys(p).filter(function (k) {
    return ~_config.DIMENSION_NAMES.indexOf(k);
  }).sort(function (k1, k2) {
    return _config.DIMENSION_NAMES.indexOf(k1) - _config.DIMENSION_NAMES.indexOf(k2);
  }).map(function (k) {
    return (0, _config["default"])(p).media[k](_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), Number.isInteger(p[k]) // Integer value
    ? "\n        flex-basis: ".concat(100 / (0, _config["default"])(p).gridSize * p[k], "%;\n        max-width: ").concat(100 / (0, _config["default"])(p).gridSize * p[k], "%;\n        display: block;\n      ") // Boolean
    : p[k] // Auto-width
    ? "\n          flex-grow: 1;\n          flex-basis: 0;\n          max-width: 100%;\n          display: block;\n        " // Hide element
    : 'display: none;');
  });
}, function (p) {
  return Object.keys(p).filter(function (k) {
    return ~offsetProps.indexOf(k);
  }).map(function (k) {
    return (0, _config["default"])(p).media[k.replace(/Offset$/, '')](_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        margin-left: ", "%;\n      "])), 100 / (0, _config["default"])(p).gridSize * p[k]);
  });
});

Col.displayName = 'Col';
var _default = Col;
exports["default"] = _default;